import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		accessToken: localStorage.getItem('accessToken'),
		refreshToken: localStorage.getItem('refreshToken'),
		userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
		alerts:[],
	},
	mutations: {
		setUserInfo(state, data) {
			localStorage.setItem('userInfo', JSON.stringify(data));
			state.userInfo = data;
		},
		alert(state, {alert, adding}) {
            adding ? state.alerts.push(alert)
				: state.alerts.shift()
		},
		login(state, tokens) {
			state.accessToken = tokens.accessToken;
			state.refreshToken = tokens.refreshToken;

			localStorage.setItem('accessToken', state.accessToken);
			localStorage.setItem('refreshToken', state.refreshToken);

			axios.defaults.headers.common['X-Auth'] = state.accessToken;
		},
		logout(state) {
			state.accessToken = '';
			state.refreshToken = '';
			state.userInfo = {};
			localStorage.removeItem('accessToken');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('userInfo');
			delete axios.defaults.headers.common['X-Auth'];
		},
	},
	actions: {
		login({commit}, tokens) {
			commit('login', tokens);
			
			commit('setUserInfo', {
				'userName': parseJwt(tokens.accessToken).full_name,
				'userAvatar': undefined
			});
		},
		logout({commit}) {
			commit('logout');
			location.href = '/';
		},
		alertAdd({commit}, alert) {
			commit('alert', { alert, adding: true});
			setTimeout(() => commit('alert', { alert, adding: false }), 5000);
		},
	},

	getters: {
		getAccessToken(state) {
			return state.accessToken;
		},
		getRefreshToken(state) {
			return state.refreshToken;
		},
		getUserInfo(state) {
			return state.userInfo;
		}
	},
	modules: {
	}
});

function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}
